/**
 * Shared broad-search formatting (2026-08-02, Phase C).
 *
 * `cleanTitleForSearch` MUST be identical on the inline FastResults page and the
 * SSR /c/list broad page, because both navigate a tapped card to
 * /compare?q=<trimmed> - if they diverged, the same product would open two
 * different comparisons. Kept here as the single source of truth.
 */

/**
 * Trim a long Google Shopping title to a clean "brand model type" search query:
 * keeps model numbers, drops the spec deluge and marketing tail, so the deep
 * comparison matches many retailers, not just the one whose long title we
 * copied. Does NOT split on a bare hyphen, so "WH-1000XM5" survives.
 */
export function cleanTitleForSearch(title: string): string {
  let s = title.split(/,|\||:|–|—|\(|\s-\s/)[0].trim();
  const words = s.split(/\s+/);
  if (words.length > 8) s = words.slice(0, 8).join(" ");
  return s.trim() || title.trim();
}

/**
 * The one-line subtitle under the heading. MUST be identical on the inline
 * FastResults page and the saved /c/list page so the two surfaces match (owner
 * request 2026-08-02). No "True Final Price" wording - broad pages show the
 * lowest LISTED price.
 */
export const BROAD_SUBTITLE =
  "Octopusden's top picks, ranked by rating, reviews and value. Tap any " +
  "product to get the best price across every Australian shop.";

/**
 * The small footnote under the cards. Shared by both surfaces. Never says
 * "True Final Price".
 */
export const BROAD_PRICE_FOOTNOTE =
  "Prices shown are the lowest listed price found. The full price (delivery, " +
  "fees and discounts, across every shop) is calculated when you tap a product.";
